<template>
    <div class="preview">
        <span class="menu-disclaimer" v-if="$root.isMobile">
            СПЕЦИАЛЬНЫЙ ПРОЕКТ
        </span>
        <div class="preview-cols">
            <div class="preview-col leftside" v-if="!$root.isMobile">
                <h1>
                    БОЛЬШЕ <br>&#160;&#160;&#160;&#160;&#160;ФУТБОЛА
                </h1>
                <div class="preview-text">
                    <p>
                        Редакция «Чемпионата» собирает для вас интересную статистику самых зрелищных матчей главного футбольного события года. Следите за ходом турнира на проекте «Больше футбола» и будьте в курсе всех деталей!
                    </p>
                </div>
            </div>
            <div class="preview-col leftside" v-else>
                <h1>
                    БОЛЬШЕ <br>&#160;&#160;ФУТБОЛА
                </h1>
                <div class="preview-text">
                    <p>
                        Редакция «Чемпионата» собирает для вас интересную статистику самых зрелищных матчей главного футбольного события года. Следите за ходом турнира на проекте «Больше футбола» и будьте в курсе всех деталей!
                    </p>
                </div>
            </div>
            <div class="preview-col rightside" v-if="matches.items">
                <div class="top-slider">
                    <swiper :options="topSliderOptions" ref="top-slider" @slideChange="getActiveIndex" @init="getActiveIndex">
                        <swiper-slide v-for="(item,index) in matches.items" :key="index">
                            <div class="top-slider-item">
                                <div class="top-slider-item-command">
                                    <div class="country-img">
                                        <img :src="item.fkParticipants1.image" alt="">
                                    </div>
                                    <span class="item-title">Сборная</span>
                                    <span class="country-name">{{item.fkParticipants1.name}}</span>
                                </div>
                                <div class="total">
                                    <span>{{item.fkParticipants1.goals}}</span>
                                    <span>X</span>
                                    <span>{{item.fkParticipants2.goals}}</span>
                                </div>
                                <div class="top-slider-item-command">
                                    <div class="country-img">
                                        <img :src="item.fkParticipants2.image" alt="">
                                    </div>
                                    <span class="item-title">Сборная</span>
                                    <span class="country-name">{{item.fkParticipants2.name}}</span>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
                <div class="top-slider-info" v-if="!$root.isMobile">
                    <div class="top-slider-datetime">
                        <div class="date">
                            <div class="icon">
                                <calendar></calendar>
                            </div>
                            <span>{{date}}</span>
                        </div>
                        <div class="time">
                            <div class="icon">
                                <watch></watch>
                            </div>
                            <span>{{time}}</span>
                        </div>
                    </div>
                    <div class="top-slider-nav">
                        <a href="#" class="top-prev-slide" @click="$root.gaSend('main', 'click', 'day slider')">
                            <arrow-prev></arrow-prev>
                        </a>
                        <a href="#" class="top-next-slide" @click="$root.gaSend('main', 'click', 'day slider')">
                            <arrow-next></arrow-next>
                        </a>
                    </div>
                </div>
                <div class="navigation-slider" v-if="menuState || !$root.isMobile">
                    <swiper :options="navigationSliderOptions" ref="navigation-slider">
                        <swiper-slide v-for="(item,index) in matches.items" :key="index" :class="{'active-item': currentIndex == index}">
                            <div class="navigation-slider-item" @click.prevent="currentIndex = index">
                                <div class="navigation-slider-item-command">
                                    <div class="country-img">
                                        <img :src="item.fkParticipants1.image" alt="">
                                    </div>
                                    <span class="country-name">{{item.fkParticipants1.name}}</span>
                                </div>
                                <span class="delimiter">X</span>
                                <div class="navigation-slider-item-command">
                                    <div class="country-img">
                                        <img :src="item.fkParticipants2.image" alt="">
                                    </div>
                                    <span class="country-name">{{item.fkParticipants2.name}}</span>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="navigation-slider-arrows" v-if="!$root.isMobile">
                        <a href="#" class="navigation-prev-slide" @click="$root.gaSend('main', 'click', 'all slider')">
                            <arrow-prev></arrow-prev>
                        </a>
                        <a href="#" class="navigation-next-slide">
                            <arrow-next></arrow-next>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import icons from '@/assets/svg/icons';
    import * as moment from 'moment';
    import 'moment/locale/ru';

    import {mapGetters} from 'vuex';

    export default {
        name: "Preview",
        props: ['matches'],
        components: {
            'calendar': icons['calendar'],
            'watch': icons['watch'],
            'arrow-next': icons.arrowNext,
            'arrow-prev': icons.arrowPrev,
        },
        data() {
            const self = this;
            return {
                self: this,
                topSliderOptions: {
                    navigation: {
                        nextEl: '.top-next-slide',
                        prevEl: '.top-prev-slide',
                    },
                    on: {
                        init() {
                            self.getActiveIndex(this);
                        },
                    }
                },
                navigationSliderOptions: {
                    slidesPerView: 4,
                    slidesPerColumn: 2,
                    slidesPerGroup: 4,
                    slideToClickedSlide: true,
                    navigation: {
                        nextEl: '.navigation-next-slide',
                        prevEl: '.navigation-prev-slide'
                    },
                    breakpoints: {
                        1023: {
                            slidesPerColumn: 1,
                            slidesPerGroup: 1,
                            direction: 'vertical',
                            slidesPerView: 'auto',
                            loop: true
                        }
                    }
                },
                time: null,
                date: null,
                currentMatch: null,
                currentIndex: 0,
            }
        },
        computed: {
            ...mapGetters({
                menuState: 'getMenuState'
            })
        },
        methods: {
            getData(value) {
                this.date = moment(value).format("DD MMM");
            },
            getTime(value) {
                this.time = moment(value).format("H:mm");
            },
            getActiveIndex(swiper){
                this.currentIndex = (!swiper) ? this.$refs['top-slider'].swiper.activeIndex : swiper.activeIndex;
                this.currentMatch = this.matches.items[this.currentIndex];
                this.$emit("changedStatistic", this.currentMatch);
            },
        },
        watch: {
            'currentMatch'(to, from) {
                let date = to.date_time,
                    time = to.date_time;
                this.getData(date);
                this.getTime(time);
            },
            'currentIndex'(to, from) {
                this.$refs['top-slider'].swiper.slideTo(to);
            }
        },
    }
</script>


// WEBPACK FOOTER //
// preview.vue?5012e4a4